<template>
  <div id="app">
    <version/>
    <Header/>
    <router-view/>
    <FooterSns/>
    <Footer/>
  </div>
</template>

<script>

/* コンポーネントの登録 */
import version from './version'
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'
import FooterSns from '@/components/common/FooterSns'

export default {
  name: 'App',
  components: {
    version,
    Header,
    Footer,
    FooterSns
  },
  watch: {
    '$route' () {
      this.setTitle()
    }
  },
  created: function () {
    this.setTitle()
  },
  methods: {
    setTitle: function () {

      let title = ''

      if (this.$route.meta.title !== '') {
        title = process.env.APP_PREFIX + this.$route.meta.title + ' | ' + process.env.APP_TITLE
      } else {
        title = process.env.APP_PREFIX + process.env.APP_TITLE
      }

      document.title = title

      document.querySelector('meta[name=\'description\']').setAttribute('content', this.$route.meta.description)
      document.querySelector('meta[property=\'og:title\']').setAttribute('content', title)
      document.querySelector('meta[property=\'og:description\']').setAttribute('content', this.$route.meta.description)

    }
  }
}

</script>

<style lang="scss">
  @import '../node_modules/ress';
  @import './assets/styles/_common.scss';
  @import './assets/styles/_margin_padding.scss';
  @import './assets/styles/anchor_button.scss';
  @import './assets/styles/style.scss';

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue